/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './onetrust-wrapper.scss';
import './modifier/enabled.scss';
import './modifier/no-spacing.scss';
